import React from "react";
import { NavLink } from "react-router-dom";

const ThemeCard = ({
  to = "",
  className = "",
  rightclassName = "",
  label,
  labelSize = "large",
  labelColor,
  Icon,
  IconColor,
  leftRight = true,
  iconType = "bg",
  IconRightColor,
  IconRight,
  iconRightType = "bg",
  children,
  header = true,
  headerWrap = true,
  body = true,
  detail,
  right,
  loading = false,
  gap = 3,
  centerItem,
  style = {},
  hover = false,
  minHeight = false,
  maxHeight = false,
  height = false,
}) => {
  const Wrapper = to ? NavLink : "div";

  const renderLeftRight = () => {
    if (!leftRight) return null;

    return (
      <>
        <div className={`left ${detail && "align-items-start"}`}>
          {Icon && (
            <div className={`icon ${IconColor} ${iconType}`}>{Icon}</div>
          )}
          <div className="icon-info">
            {label && <h1 className={`${labelColor} ${labelSize}`}>{label}</h1>}
            {detail && <p className="text-muted">{detail}</p>}
          </div>
        </div>

        {(right || IconRight) && (
          <div className={`right ${rightclassName}`}>
            {right}
            {IconRight && (
              <div className={`icon ${iconRightType} ${IconRightColor}`}>
                {IconRight}
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  const bodyStyle = {
    ...(height && { height: `${height}px` }),
    ...(minHeight && { minHeight: `${minHeight}` }),
    ...(maxHeight && { maxHeight: `${maxHeight}` }),
  };

  return (
    <Wrapper
      to={to || undefined}
      className={`theme-card gap-${gap} ${hover ? "hover" : ""} ${className}`}
      style={style}
    >
      {header && (
        <div className={`theme-card-head ${headerWrap ? "wrap" : "nowrap"}`}>
          {renderLeftRight()}
        </div>
      )}

      {loading ? (
        <div className="theme-card-body">
          <div className="theme-card-loading">
            <div className="loading-placeholder" />
          </div>
        </div>
      ) : (
        <>
          {centerItem && centerItem}
          {body && (
            <div
              className={`theme-card-body ${height ? "fix-height" : ""}`}
              style={bodyStyle}
            >
              {children}
            </div>
          )}
        </>
      )}
    </Wrapper>
  );
};

export default React.memo(ThemeCard);
